export default "how\nWhy\nHow many\nhow to"